import { useQuery } from '@apollo/client';

import { loader } from 'graphql.macro';

const apiEnvironmentQuery = loader('./apiEnvironment.graphql');

export default function useApiEnvironmentQuery(options) {
  return useQuery(apiEnvironmentQuery, options);
}
